export interface Task {
  id: string;
  title: string;
  description?: string;
  dueDate?: string;
  priority: 'high' | 'medium' | 'not-important' | null;
  urgency?: 'high' | 'medium' | 'low' | null;
  isCompleted: boolean;
  createdAt: string;
  goalId?: string; // new field for goal linkage!
  cardOrder?: number; // for drag and drop ordering
  assignees?: TaskAssignee[]; // Task assignees
  // New generated content tracking fields
  generated_document_id?: string | null;
  generated_image_id?: string | null;
  generated_research_id?: string | null;
}

export interface TaskDay {
  id: string;
  title: string;
  tasks: Task[];
}

export interface TaskAssignee {
  assignment_id: string;
  assignee_id: string;
  first_name: string;
  username: string;
  profile_picture_url?: string;
  display_name: string;
  assigned_at: string;
  assigned_by_name: string;
}

export interface TaskStats {
  totalAssigned: number;
  completedAssigned: number;
  overdue: number;
  today: number;
  thisWeek: number;
  futureOrNoDueDate: number;
}

export type TaskFormValues = {
  title: string;
  description: string;
  dueDate: string;
  priority: 'high' | 'medium' | 'not-important' | null;
  urgency?: 'high' | 'medium' | 'low' | null;
  goalId?: string;
  assigneeIds?: string[]; // Array of user IDs to assign to the task
};

export function getPriorityLabel(priority: 'high' | 'medium' | 'not-important' | null): string {
  switch (priority) {
    case 'high':
      return 'Urgent';
    case 'medium':
      return 'Normal';
    case 'not-important':
      return 'Low';
    default:
      return 'None';
  }
}
